import { render, staticRenderFns } from "./CenterBottom.vue?vue&type=template&id=01847e60&scoped=true"
import script from "./CenterBottom.vue?vue&type=script&lang=js"
export * from "./CenterBottom.vue?vue&type=script&lang=js"
import style0 from "./CenterBottom.vue?vue&type=style&index=0&id=01847e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01847e60",
  null
  
)

export default component.exports